import { render } from "./slider-list-page.vue?vue&type=template&id=1382cbcc"
import script from "./slider-list-page.vue?vue&type=script&lang=js"
export * from "./slider-list-page.vue?vue&type=script&lang=js"

import "./slider-list-page.vue?vue&type=style&index=0&id=1382cbcc&lang=scss"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__